import React, { useEffect, useRef } from 'react';
import './Tooltip.css';

const Tooltip = ({ content, visible, top, left, width, onClose }) => {
    const tooltipRef = useRef(null);

    // Cerrar tooltip al hacer click fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            // No cerrar si se hace click en un elemento que tiene un atributo data-segment-id
            // (esto indica que es un segmento clickeable)
            const clickedElement = event.target.closest('[data-segment-id]');
            if (clickedElement) {
                return; // No cerrar, dejar que handleClickSegmento maneje el cambio
            }
            
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (visible) {
            // Usar un pequeño delay para evitar conflictos con el click que abre el tooltip
            const timer = setTimeout(() => {
                document.addEventListener('mousedown', handleClickOutside);
            }, 100);
            
            return () => {
                clearTimeout(timer);
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [visible, onClose]);

    if (!visible) return null;

    const handleTooltipClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onClose();
    };

    return (
        <div 
            ref={tooltipRef}
            className="whitespace-pre-line font-japanese bg-sage-600 absolute text-slate-100 rounded-lg shadow-lg border border-sage-700 px-4 py-3 w-full text-pearl-50 cursor-pointer"
            style={{ top: top, width: width - 60, left: left - width + 30  }}
            onClick={handleTooltipClick}
        >
            {content}
            <div className="mt-2 text-sm italic text-sage-200 text-center">
                Presione para cerrar
            </div>
        </div>
    );
};

export default Tooltip;